import type { I18nService } from '@telecom/shared/services/i18n';

type LocaleMessage = Parameters<I18nService['mergeLocaleMessage']>[1];

/** 按当前语言动态注册 onboarding 文案，不支持的语言统一回退英文。 */
export function registerOnboardingLocaleMessages(
    i18nService: I18nService,
    messages: Record<string, LocaleMessage>,
    defaultLocale = 'en',
): void {
    const currentLocale = i18nService.locale.value;
    const locale = currentLocale in messages ? currentLocale : defaultLocale;
    i18nService.mergeLocaleMessage(locale, messages[locale]);
}
